import type { IExercise } from '../exercises';

export const PERSONAL_EPISODE_01_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-personal-01-01",
    "name": "胸大肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "chest-stretch",
    "tips": ["保持挺胸，感受胸肌拉伸", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/44b3505dfd8f248b6338fc5e.mp4",
    "videoUrl": "/media/collections-20261008/videos/bdebffa30323ae79188e6c08.mp4",
    "targetMuscles": ["胸大肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-02",
    "name": "三角肌后束拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "shoulder-stretch",
    "tips": ["肩膀下沉不耸肩", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-4a953a069b7e206e95457cb9.mp4",
    "videoUrl": "/media/collections-20261008/videos/30c5910d31493a2280fd45b1.mp4",
    "targetMuscles": ["三角肌后束"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-03",
    "name": "三角肌前束拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "shoulder-stretch",
    "tips": ["核心收紧不塌腰", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/5c429475c151ea89d6bdd9cd.mp4",
    "videoUrl": "/media/collections-20261008/videos/c2b72300da73f94155026d34.mp4",
    "targetMuscles": ["三角肌前束"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-04",
    "name": "背加三头拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "arm-stretch",
    "tips": ["感受背阔肌与三头肌的延展", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/3c896fd54e4c716a5e47f2d7.mp4",
    "videoUrl": "/media/collections-20261008/videos/82a7e1b5d573d2937dda082b.mp4",
    "targetMuscles": ["背阔肌", "肱三头肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-05",
    "name": "菱形肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "back-stretch",
    "tips": ["含胸沉肩，感受中背拉伸", "保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/afad30295f2322351c4c2c53.mp4",
    "videoUrl": "/media/collections-20261008/videos/385210e02ecca4ea1f2942ab.mp4",
    "targetMuscles": ["菱形肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-06",
    "name": "二头肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "arm-stretch",
    "tips": ["掌心朝外，感受二头延展", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-8f0d66d2afc823d953556e25.mp4",
    "videoUrl": "/media/collections-20261008/videos/4c34409217ec9cae6bdf3466.mp4",
    "targetMuscles": ["肱二头肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-07",
    "name": "腹肌加腹外斜肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "abs-stretch",
    "tips": ["侧屈幅度循序渐进", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/02e107b3b53d0af5a95cfeb3.mp4",
    "videoUrl": "/media/collections-20261008/videos/eeac310b95be48f2c7b117e7.mp4",
    "targetMuscles": ["腹直肌", "腹外斜肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-08",
    "name": "臀大肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "leg-stretch",
    "tips": ["腰背平直，臀部后坐", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/c0fe408b96592e3e82e3e94e.mp4",
    "videoUrl": "/media/collections-20261008/videos/bc6514e720a8a82fff5c528c.mp4",
    "targetMuscles": ["臀大肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-09",
    "name": "大腿后侧拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "leg-stretch",
    "tips": ["膝盖微屈不过伸", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/d12d1a2212ea627772449605.mp4",
    "videoUrl": "/media/collections-20261008/videos/bade1e2c1715e90806c8ab80.mp4",
    "targetMuscles": ["腘绳肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-10",
    "name": "大腿前侧拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "leg-stretch",
    "tips": ["膝盖指向地面不外翻", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/8fc2073d610f1e08982dd886.mp4",
    "videoUrl": "/media/collections-20261008/videos/32d636b01d2d920fbe1b7b02.mp4",
    "targetMuscles": ["股四头肌", "髋屈肌群"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-11",
    "name": "小腿拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "leg-stretch",
    "tips": ["脚跟踩实，感受小腿后侧拉伸", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-fc20dc2c58a072dc61cde096.mp4",
    "videoUrl": "/media/collections-20261008/videos/8ba501d88113132559be1e4b.mp4",
    "targetMuscles": ["腓肠肌", "比目鱼肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-12",
    "name": "肩胛提肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "neck",
    "tips": ["侧屈+旋转组合拉伸", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/2648483eaabd2ee0d7081cc2.mp4",
    "videoUrl": "/media/collections-20261008/videos/cabb86be311637fb87ca064a.mp4",
    "targetMuscles": ["肩胛提肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-13",
    "name": "胸锁乳突肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "neck",
    "tips": ["动作缓慢，感受颈部前侧肌肉延展", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/7e5f5daa31a48d08cdf631f2.mp4",
    "videoUrl": "/media/collections-20261008/videos/c38aa3b3e7b70f218e2244bc.mp4",
    "targetMuscles": ["胸锁乳突肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-14",
    "name": "斜角肌松解",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "neck",
    "tips": ["用指腹轻柔按压松解", "每侧保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/43dbe707a10d0f6d747c5882.mp4",
    "videoUrl": "/media/collections-20261008/videos/166f349cd88164d815ff73fb.mp4",
    "targetMuscles": ["斜角肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-personal-01-15",
    "name": "颈阔肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "neck",
    "tips": ["仰头伸展颈部前侧", "保持30-60秒"],
    "sets": 2,
    "reps": "30-60秒",
    "rpe": 3,
    "restSeconds": 15,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": false,
    "source": "私教跟练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-0401a1cb0de3a5f481a8581d.mp4",
    "videoUrl": "/media/collections-20261008/videos/cb283c9c46eb7a5bb6ec5ebb.mp4",
    "targetMuscles": ["颈阔肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
  },
];
